import { Dialog as MuiDialog, DialogProps, styled } from '@mui/material';

interface CustomDialogProps extends DialogProps {
  open: boolean;
  onClose: () => void;
  children: React.ReactNode;
}

const StyledDialog = styled(MuiDialog)(({ theme }) => ({
  '& .MuiDialog-paper': {
    maxWidth: '870px',
    width: '100%',
    margin: '16px',
    borderRadius: '8px',
    boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.1)',
  },
}));

const Dialog: React.FC<CustomDialogProps> = ({ open, onClose, children, ...props }) => {
  return (
    <StyledDialog open={open} onClose={onClose} {...props}  >
      {children}
    </StyledDialog>
  );
};

export default Dialog;
